<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/LOGO ITALVEN.png', style='height: auto;width: 160px;border-radius:5px;padding:5px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Categorias
    v-flex(xs12)
      template
        v-tabs(v-model='active', color="#048420", centered, dark)
          v-tab(:key='0', ripple='') Categorías
          v-tab(v-if="mod"  :key='1', ripple='') Posicionamiento
          v-tab-item(:key='0')
            v-card(flat='')
              v-flex(xs12)
                v-dialog(v-model='dialog', persistent max-width='700px')
                  v-container(style='background-color:white !important;max-width: 700px;')
                    v-card-title.justify-center
                        span.headline Categoria
                    div(style="margin-top: 20px;")
                        v-flex(xs12 sm12)
                            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                v-flex(xs6)
                                  v-form(enctype="multipart/form-data")
                                    v-text-field(outline
                                    readonly
                                    v-model="form.co_cat"
                                    prepend-inner-icon="description"
                                    label="Código:")

                                    v-text-field(outline
                                    readonly
                                    v-model="form.cat_des"
                                    prepend-inner-icon="description"
                                    label="Nombre:")

                                    div
                                      v-flex(xs12 sm12 md12)
                                        v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                          v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir

                div(style="margin-top:20px")
                  v-flex(xs12)
                    v-layout(wrap)
                      v-flex(xs12)
                        v-text-field(v-model='search2', append-icon='search', label='Buscar' style='width:100%;')
                v-layout(align-start='', justify-start='', row='', fill-height='')
                  v-flex(xs12 style='margin-top: 5px;')
                    v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                        v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                            span.white--text Lista de Categorias
                    v-data-table.elevation-1(:headers='headers', :items="categoria", :search='search2', style="margin-top: 5px;")
                      template(slot='items', slot-scope='props')
                        td {{ props.item.co_cat }}
                        td {{ props.item.cat_des }}
                        td(v-if='props.item.orden') {{ props.item.orden }}
                        td(v-else) Sin asignar
                        td.justify-start.layout.px-0
                                v-btn.mx-0(v-if="mod" icon, @click='editItem(props.item)', style='margin-top: -8px;')
                                    v-icon(color='teal') visibility
          v-tab-item(v-if="mod" :key='1')
            v-card(flat='')
              v-flex(xs12)
                v-card(style='border-radius: 10px;')
                  v-layout(row wrap align-center='' justify-center='')
                    v-flex(md4 sm4 xs4)
                      v-card(style='border-radius: 10px;margin: 10px;')
                        v-flex(md12 sm12 xs12 style='display: flex;justify-content: center;')
                          h3 Categorías
                        v-flex(md12 sm12 xs12 style='display: flex;justify-content: center;')
                          draggable(:list="group"  @update="checkGroups"  style='width:95%')     
                            div.item(v-for="(item, key) in group" @mouseover="drage(item)" @mouseleave="leave(item)").divk
                              v-icon.drag(v-if="item._id == drag._id") drag_indicator
                              span.txth {{item.cat_des}}
                              div.menu(@mouseover="seleccionado(item)" @mouseleave="leave(item)")
                                v-icon.icon fas fa-caret-down
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
import draggable from "vuedraggable";
export default {
  name: "mCategoria",
  components: {
    draggable
  },
  data: () => ({
    search2: "",
    drag: [],
    active: null,
    form: {
      co_cat: "",
      cat_des: "",
      orden: ""
    },
    dialog: false,
    categoria: [],
    ruta: serverImg,
    headers: [
      { text: "Codigo", value: "co_cat" },
      { text: "Nombre", value: "cat_des" },
      { text: "Orden", value: "orden" },
      { text: "Acciones" }
    ],
    editedIndex: -1,
    defaultForm: {
      co_cat: "",
      cat_des: "",
      orden: ""
    },
    group: [],
    cre: "",
    mod: "",
    elm: ""
  }),
  watch: {
    active(val) {
      console.log(val);
    }
  },
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    drage(data) {
      this.drag = data;
    },
    leave() {
      this.drag = [];
      this.selected = [];
    },
    seleccionado(data) {
      this.selected = data;
    },
    checkGroups() {
      for (let i = 0; i < this.group.length; i++) {
        this.group[i].orden = i + 1;
      }
      Api.put("categoria/ordenar", this.group)
        .then(res => {
          console.log(res.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminitalven.permisos.length; i++) {
        if (this.$store.state.adminitalven.permisos[i].ruta === "Categoria") {
          for (
            let j = 0;
            j < this.$store.state.adminitalven.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminitalven.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminitalven.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminitalven.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    initialize() {
      Api.get("categoria").then(res => {
        this.categoria = res.data;
        this.group = [];
        for (let i = 0; i < this.categoria.length; i++) {
          this.group.push(this.categoria[i]);
        }
      });
    },
    editItem(item) {
      this.editedIndex = this.categoria.indexOf(item);
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    close() {
      this.editedIndex = -1;
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      this.initialize();
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/categoria.scss";
</style>
